"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BadgeSelectComponent = exports.BadgeSelectOption = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf4 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DropDown = _interopRequireWildcard(require("../DropDown"));

var _Tags = _interopRequireWildcard(require("../Tags"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _Input = _interopRequireDefault(require("../Input"));

var _dropDown = _interopRequireDefault(require("../icons/drop-down.svg"));

var _config = require("../config/config");

var _withNamedError = _interopRequireDefault(require("../withNamedError"));

var _chunk2 = _interopRequireDefault(require("lodash/chunk"));

require("./badgeSelect.sass");

var MenuBadgeRow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuBadgeRow, _React$Component);

  function MenuBadgeRow() {
    (0, _classCallCheck2.default)(this, MenuBadgeRow);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf4.default)(MenuBadgeRow).apply(this, arguments));
  }

  (0, _createClass2.default)(MenuBadgeRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      return _react.default.createElement("div", {
        onClick: this.onClick,
        className: (0, _classnames.default)('menu-item', className)
      }, children);
    }
  }]);
  return MenuBadgeRow;
}(_react.default.Component);

var BadgeSelectOption =
/*#__PURE__*/
function (_React$Component2) {
  (0, _inherits2.default)(BadgeSelectOption, _React$Component2);

  function BadgeSelectOption() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, BadgeSelectOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf4.default)(BadgeSelectOption)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function (e) {
      _this.props.onChange && _this.props.onChange(e, e.target.checked);
    });
    return _this;
  }

  (0, _createClass2.default)(BadgeSelectOption, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          selected = _this$props2.selected,
          disabled = _this$props2.disabled;
      return _react.default.createElement("div", {
        className: "badgeselect-menu-item"
      }, _react.default.createElement(_Checkbox.default, {
        label: label,
        disabled: disabled,
        checked: selected,
        onChange: this.onChange
      }));
    }
  }]);
  return BadgeSelectOption;
}(_react.default.Component);

exports.BadgeSelectOption = BadgeSelectOption;
BadgeSelectOption.propTypes = process.env.NODE_ENV !== "production" ? {
  disabled: _propTypes.default.bool,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  value: _propTypes.default.any,
  selected: _propTypes.default.bool,
  onChange: _propTypes.default.func
} : {};

var BadgeSelectComponent =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(BadgeSelectComponent, _PureComponent);

  function BadgeSelectComponent() {
    var _getPrototypeOf3;

    var _this2;

    (0, _classCallCheck2.default)(this, BadgeSelectComponent);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf3 = (0, _getPrototypeOf4.default)(BadgeSelectComponent)).call.apply(_getPrototypeOf3, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "controlled", _this2.props.hasOwnProperty('values'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "state", {
      optionTwoColumnCount: 4,
      tagMaxCount: 3,
      filter: '',
      values: _this2.controlled ? null : _this2.props.defaultValues
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "checkAll", function (e) {
      if (!e.target.checked) {
        _this2.setValue([]);

        return;
      }

      var children = _this2.props.children;

      var items = _react.default.Children.toArray(children).map(function (item) {
        return item.props;
      });

      _this2.setValue(items);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "onSearch", function (e) {
      _this2.setState({
        filter: e.target.value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "onDropDownHide", function (e) {
      _this2.setState({
        filter: ''
      });
    });
    return _this2;
  }

  (0, _createClass2.default)(BadgeSelectComponent, [{
    key: "getValue",
    value: function getValue() {
      if (this.controlled) {
        return this.props.values || [];
      }

      return this.state.values || [];
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (!this.controlled) {
        this.setState({
          values: value
        });
      }

      this.props.onChange && this.props.onChange(value);
    }
  }, {
    key: "check",
    value: function check(props, checked) {
      var values = this.getValue();
      values = values.filter(function (element) {
        return element.value !== props.value;
      });

      if (checked) {
        values.push({
          value: props.value,
          label: props.label
        });
      }

      this.setValue(values);
    }
  }, {
    key: "formatError",
    value: function formatError(error) {
      switch ((0, _typeof2.default)(error)) {
        case 'string':
          return error;

        case 'object':
          return error[Object.keys(error)[0]];

        default:
          return 'New error format ' + JSON.stringify(error);
      }
    }
  }, {
    key: "getAllValues",
    value: function getAllValues() {
      var children = this.props.children;
      var value = this.getValue();
      return _react.default.Children.toArray(children).map(function (item) {
        return (0, _objectSpread2.default)({}, item.props, {
          selected: value.some(function (currentElement) {
            return currentElement.value == item.props.value;
          })
        });
      });
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this3 = this;

      var children = this.props.children;
      var _this$state = this.state,
          filter = _this$state.filter,
          optionTwoColumnCount = _this$state.optionTwoColumnCount;
      var value = this.getValue();

      var items = _react.default.Children.toArray(children);

      if (filter) {
        items = items.filter(function (item) {
          return item.props.label.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
        });
      }

      items = items.map(function (element) {
        return _react.default.cloneElement(element, {
          selected: value.some(function (item) {
            return item.value == element.props.value;
          }),
          onChange: function onChange(e, checked) {
            _this3.check(element.props, checked);
          }
        });
      });

      if (items.length === 0) {
        return [_react.default.createElement(MenuBadgeRow, {
          key: "row-empty",
          className: "badgeselect-menu-row"
        }, (0, _config.__)('Empty'))];
      }

      if (items.length < optionTwoColumnCount) {
        return items.map(function (item, key) {
          return _react.default.createElement(MenuBadgeRow, {
            key: key,
            className: "badgeselect-menu-row"
          }, item);
        });
      }

      return (0, _chunk2.default)(items, 2).map(function (items, key) {
        return _react.default.createElement(MenuBadgeRow, {
          key: key,
          className: "badgeselect-menu-row"
        }, items);
      });
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var selected = this.getAllValues().filter(function (element) {
        return element.selected;
      });
      var tagMaxCount = this.state.tagMaxCount;

      if (!selected.length) {
        return _react.default.createElement(_Tags.Tag, {
          className: "badgeselect-tag-more",
          key: "tag-more",
          label: (0, _config.__)('Empty')
        });
      }

      var tags = selected.slice(0, tagMaxCount).map(function (_ref) {
        var value = _ref.value,
            label = _ref.label;
        return _react.default.createElement(_Tags.Tag, {
          key: value,
          label: label
        });
      });

      if (selected.length > tagMaxCount) {
        tags.push(_react.default.createElement(_Tags.Tag, {
          className: "badgeselect-tag-more",
          key: "tag-more",
          label: (0, _config.__)('...%d more', selected.length - tagMaxCount)
        }));
      }

      return tags;
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.props.error;
      var values = this.getAllValues();
      var isAllChecked = values.every(function (item) {
        return item.selected;
      });
      var isAllIndeterminate = !isAllChecked && values.some(function (item) {
        return item.selected;
      });

      var input = _react.default.createElement("div", {
        className: (0, _classnames.default)('input badgeselect-select', {})
      }, _react.default.createElement(_Tags.default, null, this.renderTags(), _react.default.createElement(_dropDown.default, {
        className: (0, _classnames.default)('input-icon input-icon--right')
      })), error && _react.default.createElement("span", {
        className: "form-field-error"
      }, this.formatError(error)));

      return _react.default.createElement(_DropDown.default, {
        className: "badgeselect",
        trigger: input,
        align: _DropDown.ALIGN_WIDTH,
        onHide: this.onDropDownHide
      }, _react.default.createElement("div", {
        className: "badgeselect-menu"
      }, _react.default.createElement("div", {
        className: "badgeselect-menu-header"
      }, _react.default.createElement("div", {
        className: "badgeselect-menu-header-checkbox"
      }, _react.default.createElement(_Checkbox.default, {
        label: (0, _config.__)('All'),
        onChange: this.checkAll,
        checked: isAllChecked,
        indeterminate: isAllIndeterminate,
        grayscale: "true"
      })), _react.default.createElement("div", {
        className: "badgeselect-menu-header-search"
      }, _react.default.createElement(_Input.default, {
        value: this.state.filter,
        placeholder: (0, _config.__)('Fast Search'),
        onChange: this.onSearch
      }))), _react.default.createElement(_Menu.default, null, this.renderItems())));
    }
  }]);
  return BadgeSelectComponent;
}(_react.PureComponent);

exports.BadgeSelectComponent = BadgeSelectComponent;
(0, _defineProperty2.default)(BadgeSelectComponent, "defaultProps", {
  defaultValue: ''
});
BadgeSelectComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  error: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  defaultValues: _propTypes.default.array,
  values: _propTypes.default.array,
  onChange: _propTypes.default.func
} : {};

var _default = (0, _withNamedError.default)(BadgeSelectComponent);

exports.default = _default;